import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';

@Component({
  selector: 'app-course-certificate',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './course-certificate.component.html',
  styleUrl: './course-certificate.component.scss',
})
export class CourseCertificateComponent {
  course = input<ChallengeGen.Course | null>(null);
}
